export const ActionsName = (t) => {
  return {
    variation: t("sg.stateAction.typology.variationTypology"),
    suspension: t("sg.stateAction.typology.suspensiontypology"),
    renewal: t("sg.stateAction.typology.renewalTypology")
  };
};
